export default {
  SERVICE_ID: 'service_szidh7f',
  USER_ID: 'user_SiEvtmyyPRXcl78CsCTWt',
  TEMPLATE_ID: 'enohofikircharitywebsite'
}